import React from "react";
import CookieConsent from "react-cookie-consent";
import { Constants } from "../../Constants";

const SFCookieConsent = () => {
  return (
    <CookieConsent
      buttonText="Accept"
      cookieName="SF_Cookie_Consent"
      expires={150}
    >
      We use cookies on our website to give you the most relevant experience by
      remembering your preferences and repeat visits. By clicking “Accept”, you
      consent to the use of ALL the cookies.{"  "}
      <a
        href={Constants.PRIVACY_POLICY_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        View our privacy policy.
      </a>
    </CookieConsent>
  );
};

export default SFCookieConsent;
